import { render, staticRenderFns } from "./Style_guide.vue?vue&type=template&id=41cf672d"
import script from "./Style_guide.vue?vue&type=script&lang=js"
export * from "./Style_guide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports